import React, { Component } from "react";
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import TextField from '@material-ui/core/TextField';
import * as Var from 'styles/variables';
import { connect } from 'react-redux';
import { setCampaignName } from  'actions';

const styles = theme => ({
    title: {
        width: '100%',
        maxWidth: 500,
        color: Var.textColor,
        paddingTop: 8,
        paddingLeft: 8
    },
    textField: {
        marginLeft: theme.spacing(4),
        marginRight: theme.spacing(1),
        width: '80%',
    },
    areaWrapper: {
        display: 'block',
        width: '80%',
        paddingBottom: theme.spacing(2)
    }
});

export class CampaignName extends Component {
    handleChange = title => event => {
        this.props.setCampaignName(event.target.value);
    };

    render() {
        const { classes } = this.props;

        return (
            <div className={classes.areaWrapper}>
                <div>
                    <Icon className={'fa fa-user fa-sm'} /><span className={classes.title}>名前（個人、企業、媒体及びキャンペーン名）</span>
                </div>
                <TextField
                    id="standard-name"
                    className={classes.textField}
                    value={this.props.affiliatorName}
                    onChange={this.handleChange('title')}
                    margin="normal"
                    helperText=""
                />
            </div>
        );
    }
}

CampaignName.propTypes = {
    classes: PropTypes.object,
    setCampaignName: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
    affiliatorName: state.affiliate.affiliatorName
});

const mapDispatchToProps = dispatch => ({
    setCampaignName: (param) => dispatch(setCampaignName(param)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles, { withTheme: true })(CampaignName));